import React, {Component} from "react";

import TextInput from "../../../component/input/TextInput";
import Loading from "../../../component/loading/Loading";
import Alert from "../../../component/modal/Alert";
import PWModal from "../component/modal/PWModal";
import VerifyModal from "../component/modal/VerifyModal";
import UpdatePWModal from "../component/modal/UpdatePWModal";

import "../css/loginPage.css"
import loginPagecss from "../css/loginPage.module.css";

import * as apiUtil from "../../../util/apiUtil";

import * as authAction from "../store/auth";
import {bindActionCreators} from "redux";
import {connect} from "react-redux";
import {aesDecrypt, aesEncrypt} from "../../../util/aes256";

class LoginContainer extends Component {
    constructor(props) {
        super(props);

        this.setLoading = this.setLoading.bind(this);

        this.setValue = this.setValue.bind(this);
        this.loginAction = this.loginAction.bind(this);
        this.registerAction = this.registerAction.bind(this);
        this.handleChangeRemember = this.handleChangeRemember.bind(this);

        this.handleKakaoLogin = this.handleKakaoLogin.bind(this);
        this.handleNaverLogin = this.handleNaverLogin.bind(this);

        this.ajaxRequestFindId = this.ajaxRequestFindId.bind(this);
        this.ajaxRequestValidateSession = this.ajaxRequestValidateSession.bind(this);
        this.ajaxUpdatePassword = this.ajaxUpdatePassword.bind(this);

        this.handlePwModal = this.handlePwModal.bind(this);
        this.handleVerifyModal = this.handleVerifyModal.bind(this);
        this.handleUpdatePWModal = this.handleUpdatePWModal.bind(this);

        this.openAlert = this.openAlert.bind(this);
        this.closeAlert = this.closeAlert.bind(this);
        this.ajaxCountAdSrc = this.ajaxCountAdSrc.bind(this);

        this.state = {
            loading: false,

            pwModalOpen: false,
            verifyModalOpen: false,
            updatePWModalOpen: false,

            alertOpen: false,
            alertMessage: '',
            alertButtons: [],
        }
    }

    handleKakaoLogin() {
        const state = {
            oauthType: 'KAKAO'
        }
        const encodedState = encodeURIComponent(aesEncrypt(JSON.stringify(state)));

        let url = `https://kauth.kakao.com/oauth/authorize`;
        url += `?prompt=select_account`;
        url += `&client_id=${process.env.REACT_APP_SYNC_CLIENT_ID}`;
        url += `&redirect_uri=${process.env.REACT_APP_SYNC_REDIRECT_URI}`;
        url += `&response_type=code`;
        url += `&state=${encodedState}`;

        window.location.href = url;
    }
    handleNaverLogin() {
        const state = {
            oauthType: 'NAVER'
        }
        const encodedState = encodeURIComponent(aesEncrypt(JSON.stringify(state)));

        let url = `https://nid.naver.com/oauth2.0/authorize`;
        url += `?client_id=${process.env.REACT_APP_NAVER_LOGIN_CLIENT_ID}`;
        url += `&redirect_uri=${process.env.REACT_APP_NAVER_LOGIN_REDIRECT_URI}`;
        url += `&response_type=code`;
        url += `&state=${encodedState}`;

        window.location.href = url;
    }

    componentDidMount() {
        const { hstate, alimtalkRef } = this.props;
        this.ajaxCountAdSrc();

        if(hstate) {
            // 로그인 페이지에 다른 페이지로 벗어난 후 다시 진입 시 쿼리 파라미터 유실을 방지하기 위함
            window.sessionStorage.setItem('hstate', hstate);
        }
        if(alimtalkRef) {
            window.sessionStorage.setItem('alimtalkRef', alimtalkRef);
        }
    }

    async ajaxCountAdSrc() {
        const adSrc = sessionStorage.getItem('adSrc');
        const sessionId = sessionStorage.getItem('sessionId');

        apiUtil.asyncRequest({
            url: `/api/common/adpath/count`,
            method: apiUtil.requestMethod.POST,
            data: {
                adSrc,
                type: 'VISIT',
                sessionId,
            }
        });
    }

    shouldComponentUpdate(nextProps, nextState, nextContext) {
        return (
            this.state.loading !== nextState.loading
            || this.props.siteid !== nextProps.siteid
            || this.props.password !== nextProps.password
            || this.props.remember !== nextState.remember

            || this.props.idid !== nextProps.idid
            || this.props.session !== nextProps.session
            || this.props.password1 !== nextProps.password1
            || this.props.password2 !== nextProps.password2

            || this.state.pwModalOpen !== nextState.pwModalOpen
            || this.state.verifyModalOpen !== nextState.verifyModalOpen
            || this.state.updatePWModalOpen !== nextState.updatePWModalOpen

            || this.state.alertOpen !== nextState.alertOpen
            || this.state.alertMessage !== nextState.alertMessage
            || this.state.alertButtons !== nextState.alertButtons
        )
    }

    setLoading(loading) {
        this.setState({ loading: loading });
    }

    setValue(id, value) {
        const { AuthAction } = this.props;

        switch (id) {
            case "siteid":
                AuthAction.setSiteId(value);
                break;
            case "password":
                AuthAction.setPassword(value);
                break;
            case "remember":
                AuthAction.setRemember(value);
                break;

            case "idid":
                AuthAction.setIDID(value);
                break;
            case "session":
                AuthAction.setSes(value);
                break;
            case "password1":
                AuthAction.setPassword1(value);
                break;
            case "password2":
                AuthAction.setPassword2(value);
                break;
            default:
                break;
        }
    }

    loginAction() {
        const { siteid, password, remember } = this.props;

        apiUtil.signIn({
            userid: aesEncrypt(siteid),
            password: aesEncrypt(password),
            remember: remember
        });
    }

    registerAction() {
        const { hstate } = this.props;

        let url = `/register/agree`;
        if(hstate) url += `?hstate=${this.props.hstate}`;

        window.location.href = url;
    }

    handleChangeRemember(e) {
        this.setValue("remember", e.target.checked);
    }

    ajaxRequestFindId() {
        const { idid } = this.props;
        const { closeAlert } = this;

        apiUtil.asyncRequest({
            setLoading: this.setLoading,
            url: `/api/bizchat/user/find/password/session`,
            method: apiUtil.requestMethod.POST,
            data: {
                siteid: aesEncrypt(idid)
            },
            success: (result) => {
                if (result === undefined){
                    this.setState({ pwModalOpen: false });
                    this.handleVerifyModal();
                } else if (result === "2002") {
                    this.openAlert(
                        "입력하신 계정 정보와 일치하는 아이디가 확인 되지 않습니다.\nID확인을 원하는 경우에는, tf@biztalk.co.kr 로 사업자 등록증과 업체명을 함께 전달 부탁드립니다.",
                        [
                            { label: "확인", className: "btn btn-primary", onClick: function (){closeAlert()} }
                        ]
                    )
                }
            }
        })
    }

    ajaxRequestValidateSession() {
        const { idid, session } = this.props;

        apiUtil.asyncRequest({
            setLoading: this.setLoading,
            url: `/api/bizchat/user/find/password/session/validate`,
            method: apiUtil.requestMethod.POST,
            data: {
                siteid: aesEncrypt(idid),
                session: session,
            },
            success: (result) => {
                if(result === undefined){
                    this.handleVerifyModal();
                    this.handleUpdatePWModal();
                }
            }
        })
    }

    ajaxUpdatePassword() {
        const { idid, session, password1, password2 } = this.props;
        const { closeAlert } = this;

        apiUtil.asyncRequest({
            setLoading: this.setLoading,
            url: "/api/bizchat/user/find/password/update",
            method: apiUtil.requestMethod.POST,
            data: {
                siteid: aesEncrypt(idid),
                session: session,
                password1: aesEncrypt(password1),
                password2: aesEncrypt(password2),
            },
            success: (result) => {
                if (result === undefined) {
                    this.handleUpdatePWModal();
                    this.openAlert(
                        "변경이 완료되었습니다.\n변경된 비밀번호로 로그인 부탁드립니다.",
                        [
                            { label: "확인", className: "btn btn-primary", onClick: function (){closeAlert()} }
                        ]
                    )

                    const { AuthAction } = this.props;
                    AuthAction.resetPwUpdateData();
                }
            }
        })
    }

    handlePwModal() {
        const { pwModalOpen } = this.state;
        this.setValue('idid', '');
        this.setState({ pwModalOpen: ! pwModalOpen });
    }

    handleVerifyModal() {
        const { verifyModalOpen } = this.state;
        this.setState({ verifyModalOpen: ! verifyModalOpen });
    }

    handleUpdatePWModal() {
        const { updatePWModalOpen } = this.state;
        this.setState({ updatePWModalOpen: ! updatePWModalOpen });
    }

    openAlert(message, buttons) {
        this.setState({ alertOpen: true, alertMessage: message, alertButtons: buttons });
    }
    closeAlert() {
        // 2026-03-18 fix: {…this.state} 스프레드 제거
        this.setState({ alertOpen: false })
    }

    render() {
        const { loading, kkoLoginPath, nvrLoginPath } = this.state;

        const { siteid, password } = this.props;
        const { setValue, handleChangeRemember } = this;
        const { loginAction, registerAction } = this;

        const { idid, session, password1, password2 } = this.props;
        const { ajaxRequestFindId, ajaxRequestValidateSession, ajaxUpdatePassword } = this;

        const { pwModalOpen, verifyModalOpen, updatePWModalOpen } = this.state;
        const { handlePwModal, handleVerifyModal, handleUpdatePWModal } = this;

        const { alertOpen, alertMessage, alertButtons } = this.state;
        const { openAlert, closeAlert } = this;

        return (
            <React.Fragment>
                <Loading loading={loading}/>
                <div className={`container-xxl`}>
                    <div className={`${loginPagecss["body-bg"]}`}>
                        <div className={`${loginPagecss["login-logo"]} d-flex justify-content-center mt-5 pt-5`}>
                            <img src="/assets/img/logo.svg" alt={"logo"}/>
                        </div>
                        <div className="row align-items-center justify-content-center">
                            <div className={`${loginPagecss["login-box"]}`}>
                                <div className='card card-body position-relative  pt-3 pb-5'>
                                    <h3 className='text-center pb-2 pt-2'>Login</h3>
                                    <div className="form-floating mb-3">
                                        <TextInput
                                            className="form-control"
                                            type="text"
                                            id="siteid"
                                            name="siteid"
                                            value={siteid}
                                            onChange={setValue}
                                            labelPlaceholder='ID'
                                        />
                                    </div>
                                    <div className="form-floating">
                                        <TextInput
                                            className="form-control"
                                            type="password"
                                            id="password"
                                            name="password"
                                            value={password}
                                            onChange={setValue}
                                            labelPlaceholder='Password'
                                            onKeyDown={loginAction}
                                        />
                                    </div>
                                    <div className="form-check pb-3">
                                        {/*<input*/}
                                        {/*    type="checkbox"*/}
                                        {/*    className="form-check-input"*/}
                                        {/*    name={"remember"}*/}
                                        {/*    id="remember"*/}
                                        {/*    onChange={(e) => handleChangeRemember(e)}*/}
                                        {/*/>*/}
                                        {/*<label className="form-check-label" htmlFor="remember">로그인 정보 저장</label>*/}
                                    </div>
                                    <div className="btn-area">
                                        <button
                                            onClick={loginAction}
                                            type="submit"
                                            className="w-100 btn btn-primary btn-md mt-2 lh-base"
                                            // disabled={siteid === '' || password === ''}
                                            >
                                            로그인
                                        </button>

                                        {/* OAuth 로그인 버튼 시작 */}
                                        <button onClick={this.handleKakaoLogin} className="btn-kakao btn btn-md mt-2 w-100 lh-base">
                                            <img src="/assets/img/icon_kakao.png" alt="kakao"></img>
                                            <span>카카오로 시작하기</span>
                                        </button>
                                        <button onClick={this.handleNaverLogin} className="btn-naver btn btn-md mt-2 w-100 lh-base">
                                            <img src="/assets/img/icon_naver.png" alt="naver"></img>
                                            <span>네이버로 시작하기</span>
                                        </button>
                                        {/* OAuth 로그인 버튼 끝 */}

                                    </div>
                                    
                                    <div className={"d-flex justify-content-center align-items-center"}>
                                        <div className="mt-4 d-flex justify-content-between fs-6">
                                            <button
                                                className='px-2'
                                                onClick={handlePwModal}
                                                style={{
                                                    backgroundColor: 'transparent',
                                                    border: 'none',
                                                    padding: 0,
                                                    cursor: 'pointer'
                                                }}
                                            >비밀번호 찾기
                                            </button>
                                            |
                                            <button
                                                className='px-2'
                                                onClick={registerAction}
                                                style={{
                                                    backgroundColor: 'transparent',
                                                    border: 'none',
                                                    padding: 0,
                                                    cursor: 'pointer'
                                                }}
                                            >회원가입 하기
                                            </button>
                                        </div>
                                    </div>
                                    <div className="bottom-line"></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <PWModal
                    open={pwModalOpen}
                    findIdAction={ajaxRequestFindId}
                    idid={idid}
                    setValue={setValue}
                    handleClose={handlePwModal}
                />
                <VerifyModal
                    open={verifyModalOpen}
                    validateSessionAction={ajaxRequestValidateSession}
                    idid={idid}
                    session={session}
                    setValue={setValue}
                    handleClose={handleVerifyModal}
                    openAlert={openAlert}
                    closeAlert={closeAlert}
                    findIdAction={ajaxRequestFindId}
                />
                <UpdatePWModal
                    open={updatePWModalOpen}
                    updatePasswordAction={ajaxUpdatePassword}
                    idid={idid}
                    session={session}
                    password1={password1}
                    password2={password2}
                    setValue={setValue}
                    handleClose={handleUpdatePWModal}
                />

                <Alert
                    isOpen={alertOpen}
                    handleClose={closeAlert}
                    message={alertMessage}
                    buttons={alertButtons}
                />
            </React.Fragment>
        )
    }
}

export default connect(
    (state) => ({
        siteid: state.auth.get('siteid'),
        password: state.auth.get('password'),
        remember: state.auth.get('remember'),

        idid: state.auth.get('idid'),
        session: state.auth.get('session'),
        password1: state.auth.get('password1'),
        password2: state.auth.get('password2'),
    }),
    (dispatch) => ({
        AuthAction: bindActionCreators(authAction, dispatch),
    })
)(LoginContainer);
